//@flow
import React, { useState } from 'react';
import { useViewport } from 'components/templates/viewportProvider';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { HTMLView } from 'components/atoms/htmlView';
import './styles.scss';

type DataPropType = {
  name: string,
  roleShortDescription: string,
  roleLongDescription: string,
  jobLongDescription: string,
  department: string,
  verticalName: string,
  city: string,
  country: string,
  business: string,
};

type Props = {
  data: Object<DataPropType>,
  roleName?: string,
};

const AboutRoleMobileView = (props: Props) => {
  const { roleName } = props;
  const {
    name,
    roleShortDescription,
    roleLongDescription,
    jobLongDescription,
    department,
    business,
    city,
  } = props.data;
  const { height } = useViewport();
  const [selected_link_id, set_selected_link_id] = useState(0);

  const handleFeatureSelected = id => {
    set_selected_link_id(id);
  };

  const renderAboutRoleDetails = () => {
    return (
      <div className={'about-role-details-body normal-scroll'}>
        <div className={'about-role-details-container'}>
          <HTMLView
            html={roleShortDescription}
            tagName={'h4'}
            className={'heading-description'}
          />
          <Row className={'row-one'}>
            <Col xs={{ span: 6 }}>
              <h6>Department</h6>
              <p>{department}</p>
            </Col>
            <Col xs={{ span: 6 }}>
              <h6>Business</h6>
              <p>{business}</p>
            </Col>
          </Row>
          <Row className={'row-two'}>
            <Col xs={{ span: 6 }}>
              <h6>Location</h6>
              <p>{city}</p>
            </Col>
          </Row>
        </div>
      </div>
    );
  };

  const renderRoleDescription = () => {
    return (
      <div className={'role-card-body normal-scroll'}>
        <HTMLView
          html={roleLongDescription}
          tagName={'p'}
          className={'role-long-description'}
        />
      </div>
    );
  };

  const renderJobDescription = () => {
    return (
      <div className={'job-card-body normal-scroll'}>
        <HTMLView
          html={jobLongDescription}
          tagName={'p'}
          className={'job-long-description'}
        />
      </div>
    );
  };

  const carousal_data = [
    {
      title: 'ABOUT THE ROLE',
      classname: 'about-role',
      id: 0,
      data: renderAboutRoleDetails(),
    },
    {
      title: 'ROLE DESCRIPTION',
      classname: 'role-description',
      id: 1,
      data: renderRoleDescription(),
    },
    {
      title: 'JOB DESCRIPTION',
      classname: 'job-description',
      id: 2,
      data: renderJobDescription(),
    },
  ];

  return (
    <div className="about-role-mobile-body" style={{ height }}>
      <div className="inner-section">
        <h2 className="heading">{name}</h2>
        <HorizontalCarousel
          cssFor={'horizontal-carousel-container'}
          featureSelected={id => {
            handleFeatureSelected(id);
          }}
          selectedLinkId={selected_link_id}
          type={'text-carousal-finite-scroll'}
          data={carousal_data}
        />
        {carousal_data[selected_link_id].data}
      </div>
    </div>
  );
};
export default AboutRoleMobileView;
